var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "socials-icon/dark/default/facebook"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "M23.5 12.5694C23.5 6.21811 18.3513 1.06939 12 1.06939C5.64872 1.06939 0.5 6.21811 0.5 12.5694C0.5 18.3094 4.70538 23.067 10.2031 23.9297V15.8936H7.2832V12.5694H10.2031V10.0358C10.2031 7.15361 11.92 5.56158 14.5468 5.56158C15.805 5.56158 17.1211 5.78619 17.1211 5.78619V8.61627H15.671C14.2424 8.61627 13.7969 9.50273 13.7969 10.4122V12.5694H16.9863L16.4765 15.8936H13.7969V23.9297C19.2946 23.067 23.5 18.3094 23.5 12.5694Z",
    fill: "#5C5F66"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.9fc4addf5f92da9757139b4c8ce92e45.svg";
export { ForwardRef as ReactComponent };